import { InputParameterHierarchyType } from '../../../InputParameterHierarchy/model'
import { EmailTypeKind } from '../../../../models/EmailType'

export type IphContextParam = 'meetingTemplateId' | 'emailTypeId' | 'documentTypeId'

export const IPH_CONTEXT_PARAM: Record<InputParameterHierarchyType, IphContextParam> = {
  [InputParameterHierarchyType.AI_FEATURE_PRESET]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_SUMMARY_TEMPLATE]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_PREPARATION_TEMPLATE]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_PREPARATION_EMAIL_TEMPLATE]: 'meetingTemplateId',
  [InputParameterHierarchyType.MEETING_AGENDA_CONFIG]: 'meetingTemplateId',
  [InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE]: 'emailTypeId',
  [InputParameterHierarchyType.NEW_EMAIL_TEMPLATE]: 'emailTypeId',
  [InputParameterHierarchyType.DOCUMENT_SUMMARY_TEMPLATE]: 'documentTypeId',
}

export const isIphType = (value: string): value is InputParameterHierarchyType => Object.hasOwn(IPH_CONTEXT_PARAM, value)

export const EMAIL_TYPE_KIND_BY_IPH_TYPE: Record<
  InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE | InputParameterHierarchyType.NEW_EMAIL_TEMPLATE,
  EmailTypeKind
> = {
  [InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE]: EmailTypeKind.REPLY,
  [InputParameterHierarchyType.NEW_EMAIL_TEMPLATE]: EmailTypeKind.NEW,
}

export const isEmailIphType = (
  value: InputParameterHierarchyType,
): value is InputParameterHierarchyType.EMAIL_RESPONSE_TEMPLATE | InputParameterHierarchyType.NEW_EMAIL_TEMPLATE => IPH_CONTEXT_PARAM[value] === 'emailTypeId'

export const isMeetingTemplateIphType = (value: InputParameterHierarchyType) => IPH_CONTEXT_PARAM[value] === 'meetingTemplateId'
